export const trackEvent = (event: string, data = {}): void => {
  try {
    window.amplitude
      .getInstance()
      .logEvent(event, { property: 'check-my-pill', ...data });
  } catch {
    console.error('Amplitude not loaded');
  }
};
